module.exports = __webpack_public_path__ + "img/flipper.f2ff7329.jpg";